import script from "./ActivityWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityWidget.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityWidget.vue?vue&type=style&index=0&id=4da02d20&lang=scss&scoped=true"
import "./ActivityWidget.vue?vue&type=style&index=1&id=4da02d20&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da02d20"]])

export default __exports__